import { getApiBaseUrl, SALON_API_PREFIX } from './apiConfig';

const STORAGE_KEY_PREFIXES = ['public-assets/', 'portal-logos/'];

function isVercelBlobUrl(url) {
  if (!url || typeof url !== 'string') return false;
  try {
    const u = new URL(url);
    const host = (u.hostname || '').toLowerCase();
    return (
      u.protocol === 'https:' &&
      (host === 'blob.vercel-storage.com' ||
        host.endsWith('.blob.vercel-storage.com') ||
        host === 'public.blob.vercel-storage.com' ||
        host.endsWith('.public.blob.vercel-storage.com'))
    );
  } catch {
    return false;
  }
}

function isE2eObjectStoreUrl(url) {
  return /objectstore\.e2enetworks\.net/i.test(url) || /\.e2enetworks/i.test(url);
}

function isStorageObjectKey(path) {
  const clean = String(path || '').replace(/^\//, '').split('?')[0];
  return STORAGE_KEY_PREFIXES.some((prefix) => clean.startsWith(prefix));
}

function extractFirstMediaRef(value) {
  if (!value) return null;
  let raw = value;
  if (Array.isArray(raw)) raw = raw[0];
  if (typeof raw !== 'string') return null;
  const trimmed = raw.trim();
  if (trimmed.startsWith('[')) {
    try {
      const parsed = JSON.parse(trimmed);
      if (Array.isArray(parsed) && parsed[0]) raw = parsed[0];
    } catch {
      // ignore
    }
  }
  if (!raw || typeof raw !== 'string') return null;
  return raw.trim();
}

function needsSalonBlobProxy(url) {
  return isVercelBlobUrl(url) || isE2eObjectStoreUrl(url) || isStorageObjectKey(url);
}

/** Resolve treatment/product/media URLs for the salon kiosk (Vercel Blob, E2E keys, presigned URLs). */
export function resolveSalonMediaUrl(value) {
  const raw = extractFirstMediaRef(value);
  if (!raw) return null;
  if (raw.startsWith('data:') || raw.startsWith('blob:')) return raw;
  if (!needsSalonBlobProxy(raw)) return raw;
  const base = (getApiBaseUrl() || '').replace(/\/$/, '');
  if (!base) return raw;
  return `${base}${SALON_API_PREFIX}/blob-proxy?url=${encodeURIComponent(raw)}`;
}
